@if (productData && hasValidTranslations) {
<section class="section-3 mt-4 pt-4 mb-6 mb-lg-7">
    @for (overviewKeys of groupedContent['SECTION-3']; track overviewKeys) { @if
    (overviewKeys.headingText || overviewKeys.descriptionText) {
    <div class="container text-center mb-4">
        <div class="col-12 col-md-8 col-lg-10 offset-md-2 offset-lg-1">
            @if (overviewKeys.headingText) {
            <h2
                [innerHTML]="overviewKeys.headingText"
                class="text-blue-300"
            ></h2>
            } @if (overviewKeys.descriptionText) {
            <div [innerHTML]="overviewKeys.descriptionText"></div>
            }
        </div>
    </div>
    } } @for (sideBySide0Keys of
    groupedContent['SECTION-3_SIDE-BY-SIDE-overview']; track sideBySide0Keys) {
    @if ( sideBySide0Keys.buttonText || sideBySide0Keys.buttonUrl ||
    sideBySide0Keys.descriptionText || sideBySide0Keys.headingText ||
    sideBySide0Keys.imageUrl || sideBySide0Keys.imageAltText ||
    sideBySide0Keys.linkText || sideBySide0Keys.linkUrl ||
    sideBySide0Keys.videoId ) {
    <vision2-side-by-side
        [buttonText]="sideBySide0Keys.buttonText"
        [buttonUrl]="sideBySide0Keys.buttonUrl"
        [description]="sideBySide0Keys.descriptionText"
        [image]="sideBySide0Keys.imageUrl"
        [imageAlt]="sideBySide0Keys.imageAltText"
        [linkUrl]="sideBySide0Keys.linkUrl"
        [linkText]="sideBySide0Keys.linkText"
        [modalVideoId]="sideBySide0Keys.videoId"
        [heading]="sideBySide0Keys.headingText"
        [centered]="true"
        [colorClass]="'bg-gray-30'"
        [contentColor]="'bg-transparent'"
        [headingValue]="2"
        [type]="'right'"
        [contentClass]="'col-sm-10 col-lg-6 col-xl-4'"
        [imageClass]="'col-sm-10 col-lg-6 col-xl-5 offset-xl-1'"
        verticalPadding="py-4"
    >
    </vision2-side-by-side>
    } } @if (groupedContent['SECTION-3_INLINE-BANNER'].length > 0) {
    <div class="container-fluid my-lg-7 my-md-6 my-sm-5 my-4">
        @for( inlineBannerKeys of groupedContent['SECTION-3_INLINE-BANNER'];
        track inlineBannerKeys; let i = $index; let odd = $odd) { @if (
        inlineBannerKeys.buttonText || inlineBannerKeys.buttonUrl ||
        inlineBannerKeys.descriptionText || inlineBannerKeys.headingText ||
        inlineBannerKeys.desktopImageUrl || inlineBannerKeys.tabletImageUrl ||
        inlineBannerKeys.mobileImageUrl || inlineBannerKeys.imageAltText ||
        inlineBannerKeys.tabletImageAltText ||
        inlineBannerKeys.mobileImageAltText || inlineBannerKeys.linkText ||
        inlineBannerKeys.linkUrl || inlineBannerKeys.videoId ) {
        <div class="mb-4 mb-md-5 mb-lg-6">
            <div class="container">
                <vision2-inline-banner
                    [backgroundImage]="inlineBannerKeys.desktopImageUrl"
                    [backgroundImageTablet]="inlineBannerKeys.tabletImageUrl"
                    [backgroundImageMobile]="inlineBannerKeys.mobileImageUrl"
                    [backgroundImageAltText]="inlineBannerKeys.imageAltText"
                    [backgroundImageTabletAltText]="
                        inlineBannerKeys.tabletImageAltText
                    "
                    [backgroundImageMobileAltText]="
                        inlineBannerKeys.mobileImageAltText
                    "
                    [buttonText]="inlineBannerKeys.buttonText"
                    [buttonUrl]="inlineBannerKeys.buttonUrl"
                    [colorClass]="'text-bg-gray-20'"
                    [description]="inlineBannerKeys.descriptionText"
                    [heading]="inlineBannerKeys.headingText"
                    [headingValue]="2"
                    [linkText]="inlineBannerKeys.linkText"
                    [linkUrl]="inlineBannerKeys.linkUrl"
                    [type]="odd ? 'right' : 'left'"
                    [modalVideoId]="inlineBannerKeys.videoId"
                >
                </vision2-inline-banner>
            </div>
        </div>
        } }
    </div>
    } @for (sideBySideKeys of groupedContent['SECTION-3_SIDE-BY-SIDE']; track
    sideBySideKeys; let i = $index; let odd = $odd) { @if (
    sideBySideKeys.buttonText || sideBySideKeys.buttonUrl ||
    sideBySideKeys.descriptionText || sideBySideKeys.headingText ||
    sideBySideKeys.imageUrl || sideBySideKeys.imageAltText ||
    sideBySideKeys.linkText || sideBySideKeys.linkUrl || sideBySideKeys.videoId
    ) {
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-sm-10 col-lg-12 col-xl-10 ps-2">
                <vision2-side-by-side
                    [buttonText]="sideBySideKeys.buttonText"
                    [buttonUrl]="sideBySideKeys.buttonUrl"
                    [description]="sideBySideKeys.descriptionText"
                    [image]="sideBySideKeys.imageUrl"
                    [imageAlt]="sideBySideKeys.imageAltText"
                    [linkUrl]="sideBySideKeys.linkUrl"
                    [linkText]="sideBySideKeys.linkText"
                    [modalVideoId]="sideBySideKeys.videoId"
                    [heading]="sideBySideKeys.headingText"
                    [buttonClass]="'btn - primary'"
                    [centered]="false"
                    [containerType]="'container-fluid'"
                    [contentClass]="
                        odd
                            ? 'col-lg-6 pe-lg-1 pe-xl-2 pt-2 pt-md-4 pt-lg-0'
                            : 'col-lg-6 ps-lg-1 ps-xl-2 pt-2 pt-md-4 pt-lg-0'
                    "
                    [contentPadding]="
                        'pt-4 pt-lg-4 pt-xl-6 pb-4 pb-lg-4 pb-xl-6 px-2 px-xl-4 text-bg-gray-20 rounded-4'
                    "
                    [contentColor]="'bg-gray-20'"
                    [headingValue]="2"
                    [imageClass]="
                        odd
                            ? 'col-lg-6 pe-lg-1 pe-xl-2'
                            : 'col-lg-6 ps-lg-1 ps-xl-2'
                    "
                    [type]="odd ? 'left' : 'right'"
                    [verticalPadding]="'mt-4 mt-sm-6 mt-lg-6'"
                >
                </vision2-side-by-side>
            </div>
        </div>
    </div>
    } } @if (groupedContent['SECTION-3_CONTENT-BLOCK'].length > 0) {
    <div class="container">
        <div class="row justify-content-center mt-4 mt-sm-6 mt-lg-6">
            @for (cardKeys of groupedContent['SECTION-3_CONTENT-BLOCK']; track
            cardKeys; let i = $index) { @if ( cardKeys.buttonText ||
            cardKeys.buttonUrl || cardKeys.descriptionText ||
            cardKeys.headingText || cardKeys.imageUrl || cardKeys.imageAltText
            || cardKeys.linkText || cardKeys.linkUrl || cardKeys.videoId ) {
            <div
                class="col-12 col-sm-10 col-md-6 col-lg-4 pb-0 px-0 card-container"
            >
                <vision2-card
                    [buttonText]="cardKeys.buttonText"
                    [buttonUrl]="cardKeys.buttonUrl"
                    [description]="cardKeys.descriptionText"
                    [headingValue]="4"
                    [image]="cardKeys.imageUrl"
                    [imageAlt]="cardKeys.imageAltText"
                    [imageClass]="'rounded-4 w-100 mb-3'"
                    [imageSizes]="
                        '(min-width: 992px) 26vw, (min-width: 768px) 50vw, (min-width: 575px) 84vw, 100vw'
                    "
                    [linkUrl]="cardKeys.linkUrl"
                    [linkText]="cardKeys.linkText"
                    [modalVideoId]="cardKeys.videoId"
                    [title]="cardKeys.headingText"
                    [cardClass]="'pt-0 px-2 mx-auto text-center text-bg-light'"
                    [cardColor]="'bg-transparent'"
                >
                </vision2-card>
            </div>
            } }
        </div>
    </div>
    }
</section>
}
